"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const immutable_1 = require("immutable");
const classnames_1 = __importDefault(require("classnames"));
const AttachFile_1 = __importDefault(require("@mui/icons-material/AttachFile"));
const OutlinedFlag_1 = __importDefault(require("@mui/icons-material/OutlinedFlag"));
const ArrowUpward_1 = __importDefault(require("@mui/icons-material/ArrowUpward"));
const Visibility_1 = __importDefault(require("@mui/icons-material/Visibility"));
const core_1 = require("companion-app-components/utils/core");
const datasets_1 = require("companion-app-components/flux/datasets");
const accounts_1 = require("companion-app-components/flux/accounts");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const auth_1 = require("companion-app-components/flux/auth");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const transactionListSelectors = __importStar(require("data/transactionList/selectors"));
const utils_1 = require("data/transactions/utils");
const selectors_1 = require("data/datasetSharing/selectors");
const QCheckbox_1 = __importDefault(require("components/QCheckbox"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const ReconcilePanel_1 = __importDefault(require("components/ReconcilePanel"));
const TransactionCalendar_1 = __importDefault(require("components/TransactionCalendar"));
const RegPrefsModal_1 = __importDefault(require("containers/Transactions/RegPrefsModal"));
const TxPrefMenu_1 = __importDefault(require("components/TransactionRegister/TxPrefMenu"));
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const helpers_1 = require("../helpers");
const RegControlBar_1 = __importDefault(require("../RegControlBar"));
const RegMEditBar_1 = __importDefault(require("../RegMEditBar"));
const txConfig = __importStar(require("../transactionsConfig"));
const styles_1 = require("./styles");
const log = (0, core_1.getLogger)('components/RegisterHeader/index.tsx');
//
// The control bar at the top of the Transaction list (register)
//
const useStyle = (0, mui_1.makeStyles)()(styles_1.styles);
const draggingOver = false;
const RegisterHeader = (props) => {
    const [showRegPrefs, setShowRegPrefs] = (0, react_1.useState)(false);
    const [showReconcile, setShowReconcile] = (0, react_1.useState)(false);
    const [showCalendar, setShowCalendar] = (0, react_1.useState)(false);
    const [headerFields, setHeaderFields] = (0, react_1.useState)(props.headerFields);
    const [showIsReviewedColumn, setShowIsReviewedColumn] = (0, react_1.useState)(true);
    const fieldToDrop = (0, react_1.useRef)(null);
    const origList = (0, react_1.useRef)(null);
    const draggingOverRef = (0, react_1.useRef)(null);
    const { classes, theme } = useStyle();
    const { datasetPreferences, setDatasetPreference } = (0, useQPreferences_1.default)();
    const datasetId = (0, react_redux_1.useSelector)((state) => auth_1.authSelectors.getDatasetId(state));
    const datasetsById = (0, react_redux_1.useSelector)((state) => datasets_1.datasetsSelectors.getDatasetsById(state));
    const featureFlags = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state));
    const hasWriteAccess = (0, react_redux_1.useSelector)((state) => (0, selectors_1.hasDatasetWriteAccess)(state));
    const suggestCategoryForUncategorized = featureFlags.get('suggestCategoryForUncategorized');
    const TransactionsWithCategorySuggestion = (0, react_redux_1.useSelector)((state) => transactionListSelectors.getTransactionsWithCategorySuggestions(state, { accountIds: props.accountIds }));
    const transactionsWithCategorySuggestions = suggestCategoryForUncategorized ? TransactionsWithCategorySuggestion : (0, immutable_1.List)();
    const accountsById = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getAccountsById(state));
    const accountsFilter = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getAccountsByIds(state, props.accountIds));
    const txnCancelExtraColumn = featureFlags.get('txnCancelExtraColumn');
    const reconcileAccount = featureFlags.get('reconcileAccount');
    const transactionCalendar = featureFlags.get('transactionCalendar');
    const scheduledTransactionsInRegister = featureFlags.get('scheduledTransactionsInRegister');
    const isQWinDataset = datasets_1.datasetsUtils.isWindowsDataset(datasetsById.get(datasetId));
    const isEntityShareEnableUser = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isEntityShareUser);
    const location = (0, react_router_dom_1.useLocation)();
    (0, react_1.useEffect)(() => {
        setHeaderFields(props.headerFields);
    }, [props.headerFields]);
    (0, react_1.useEffect)(() => {
        setShowIsReviewedColumn(accountsFilter.some((account) => Boolean((0, utils_1.shouldShowReviewField)(account.id))));
    }, [props.accountIds, accountsFilter]);
    const onDragStart = (event, field) => {
        event.dataTransfer.setData('text', field);
        fieldToDrop.current = field;
        origList.current = headerFields;
    };
    const alterHeader = (fromField, toField) => {
        const workArray = headerFields.toArray();
        const fromIndex = workArray.indexOf(fromField);
        const initialToIndex = workArray.indexOf(toField);
        const adjust = fromIndex <= initialToIndex ? 1 : 0;
        const temp = workArray[fromIndex];
        workArray.splice(fromIndex, 1); // delete fromField from list
        const toIndex = workArray.indexOf(toField);
        workArray.splice(toIndex + adjust, 0, temp); // insert fromField back to list either before or after the to item
        if (JSON.stringify(headerFields.toArray()) !== JSON.stringify(workArray)) {
            setHeaderFields((0, immutable_1.List)(workArray));
        }
    };
    const onDragOver = (event, field) => {
        // eslint-disable-next-line react/no-unused-class-component-methods
        draggingOverRef.current = field;
        if (fieldToDrop.current && (fieldToDrop.current !== field)) {
            alterHeader(fieldToDrop.current, field);
        }
        event.preventDefault(); // not fully sure what this prevents, but without this, the onDrop is never invoked
    };
    const saveCurrentHeader = () => {
        props.callbacks.alterHeader(headerFields);
    };
    const onDrop = (event) => {
        event.preventDefault();
        if (fieldToDrop.current) {
            saveCurrentHeader();
        }
        fieldToDrop.current = null;
    };
    const onDragEnd = () => {
        if (fieldToDrop.current) {
            fieldToDrop.current = null;
            draggingOverRef.current = null;
            setHeaderFields(origList.current);
        }
    };
    const maybeCancel = () => {
        props.callbacks.maybeSaveTxnBeingEdited(() => {
            props.callbacks.cancelEdit();
        });
    };
    const handleSettingsChange = (value) => {
        switch (value) {
            case 'compact':
            case 'comfortable':
            case 'normal':
                setDatasetPreference({ transactionRegister: { registerComfort: value } });
                break;
            case 'preferences':
                setShowRegPrefs(true);
                break;
            case 'reconcile':
                if (reconcileAccount) {
                    setShowReconcile(true);
                }
                break;
            case 'calendar':
                if (transactionCalendar) {
                    setShowCalendar(true);
                }
                break;
            default:
                break;
        }
    };
    const closeRegPrefs = () => {
        setShowRegPrefs(false);
    };
    const defaultHeaderItem = (field, sortClass, extraClasses) => (<styles_1.HdrListItem id={`${field}-header`} privateKey={`regHdr:${field}`} fieldName={field} onClick={(e) => { var _a, _b; return (_b = (_a = props.callbacks) === null || _a === void 0 ? void 0 : _a.headerClick) === null || _b === void 0 ? void 0 : _b.call(_a, e, field); }} {...props} {...extraClasses}>
      <styles_1.ColumnField>
        {txConfig.fieldData[field].label}
      </styles_1.ColumnField>
      {props.sortBy === field &&
            <ArrowUpward_1.default className={classes[sortClass]} viewBox="-1 -1 27 27"/>}
    </styles_1.HdrListItem>);
    const renderFields = (options) => {
        const { callbacks } = props;
        const { sortClass, antiSortClass, showBalance } = options;
        const retRow = [];
        headerFields === null || headerFields === void 0 ? void 0 : headerFields.forEach((field) => {
            var _a;
            let privateClassName;
            switch (field) {
                case 'action':
                    privateClassName = (0, classnames_1.default)(classes.regItem, 'click', 'protectWidth');
                    retRow.push(defaultHeaderItem(field, sortClass, { privateClassName }));
                    break;
                case 'security':
                    privateClassName = (0, classnames_1.default)(classes.regItem, 'click', 'protectWidth');
                    retRow.push(defaultHeaderItem(field, sortClass, { privateClassName }));
                    break;
                case 'quantity':
                    privateClassName = (0, classnames_1.default)(classes.regItem, 'click', 'quantity', 'amount');
                    retRow.push(defaultHeaderItem(field, sortClass, { privateClassName }));
                    break;
                case 'price':
                    privateClassName = (0, classnames_1.default)(classes.regItem, 'click', 'protectWidth', 'amount');
                    retRow.push(defaultHeaderItem(field, sortClass, { privateClassName }));
                    break;
                //--------------------------------------------
                // MATCH FIELD
                //--------------------------------------------
                case 'match':
                    retRow.push(<styles_1.HdrListItem id="match-header" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={classes.iconColumn}>
            </styles_1.HdrListItem>);
                    break;
                //--------------------------------------------
                // REVIEWED FIELD
                //--------------------------------------------
                case 'reviewed': {
                    // const filterState = props.uiState.reviewedFilterState;
                    // const CheckCircleComponent = filterState !== 'none' ? CheckCircleIcon : CheckCircleOutline;
                    retRow.push(<styles_1.HdrListItem id="reviewed-header" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={(0, classnames_1.default)(classes.iconButtonColumn)} onClick={(e) => callbacks.headerClick(e, 'reviewed')}>
            </styles_1.HdrListItem>);
                    break;
                }
                //--------------------------------------------
                // FLAG FIELD
                //--------------------------------------------
                case 'userFlag':
                    retRow.push(<styles_1.HdrListItem id="flag-header" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={classes.iconButtonColumn}>
              <OutlinedFlag_1.default style={{ fontSize: 20 }}/>
            </styles_1.HdrListItem>);
                    break;
                //--------------------------------------------
                // IGNORED FIELD
                //--------------------------------------------
                case 'ignored':
                    retRow.push(<styles_1.HdrListItem id="ignored-header" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={classes.iconButtonColumn}>
              <Visibility_1.default style={{ fontSize: 20 }}/>
            </styles_1.HdrListItem>);
                    break;
                //--------------------------------------------
                // SELECT FIELD
                //--------------------------------------------
                case 'select':
                    retRow.push(<styles_1.HdrListItem id="regHdrSelectAll" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={classes.iconButtonColumn}>
              {/* @ts-expect-error: missing properties */}
              <QTip_1.default title="Select / Unselect all visible transactions">
                <QCheckbox_1.default size={theme.components.register.checkboxSize} color="primary" inputProps={{ 'aria-label': 'Search Transactions' }} className={classes.checkBox} onChange={(e, v) => {
                            callbacks.onCheckAll(v);
                        }} checked={props.uiState.allSelected} disabled={!hasWriteAccess}/>
              </QTip_1.default>
            </styles_1.HdrListItem>);
                    break;
                //--------------------------------------------
                // ACCOUNT NAME FIELD
                //--------------------------------------------
                case 'account': {
                    const hide = props.showAccountColors || props.accountIds.size === 1;
                    const hideClass = hide ? classes.nop : '';
                    const sizeClass = props.showAccountColors ? '' : 'protectWidth';
                    retRow.push(<styles_1.HdrListItem id="account-name-header" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={(0, classnames_1.default)(classes.regItem, 'click', classes.accountFieldName, sizeClass, hideClass)} style={{ cursor: 'default' }}>
              <styles_1.ColumnField>
                {txConfig.fieldData[field].label}
              </styles_1.ColumnField>
            </styles_1.HdrListItem>);
                    break;
                }
                //--------------------------------------------
                // ACCOUNT COLOR FIELD
                //--------------------------------------------
                case 'accountColor': {
                    const hideClass = !props.showAccountColors ? classes.nop : '';
                    retRow.push(<styles_1.HdrListItem id="account-color-header" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={(0, classnames_1.default)(classes.accountFieldColor, hideClass)}>
              <div className={classes.accountFieldColor}>
              </div>
            </styles_1.HdrListItem>);
                    break;
                }
                //--------------------------------------------
                // POSTED_ON FIELD
                //--------------------------------------------
                case 'postedOn':
                    retRow.push(<styles_1.HdrListItem id="posted-on-header" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={(0, classnames_1.default)(classes.regItem, 'click', 'protectWidthDate')} onClick={(e) => callbacks.headerClick(e, 'date')}>
              <styles_1.ColumnField>
                {txConfig.fieldData[field].label}
              </styles_1.ColumnField>
              {props.sortBy === 'date' &&
                            <ArrowUpward_1.default className={classes[sortClass]} viewBox="0 0 29 29"/>}
            </styles_1.HdrListItem>);
                    break;
                //--------------------------------------------
                // CHECKNUM FIELD
                //--------------------------------------------
                case 'check':
                    retRow.push(<styles_1.HdrListItem id="checknum-header" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={(0, classnames_1.default)(classes.regItem)} onClick={(e) => callbacks.headerClick(e, 'check')}>
              <styles_1.ColumnField>
                {txConfig.fieldData[field].label}
              </styles_1.ColumnField>
              {props.sortBy === 'check' &&
                            <ArrowUpward_1.default className={classes[sortClass]} viewBox="0 0 29 29"/>}
            </styles_1.HdrListItem>);
                    break;
                //--------------------------------------------
                // TAGS FIELD
                //--------------------------------------------
                case 'tags':
                    retRow.push(<styles_1.HdrListItem id="tags-header" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={(0, classnames_1.default)(classes.regItem, 'flex2')}>
              <styles_1.ColumnField>
                {txConfig.fieldData[field].label}
              </styles_1.ColumnField>
            </styles_1.HdrListItem>);
                    break;
                //--------------------------------------------
                // PAYEE FIELD
                //--------------------------------------------
                case 'payee':
                    retRow.push(<styles_1.HdrListItem id="payee-header" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={(0, classnames_1.default)(classes.regItem, 'flex2', 'click')} onClick={(e) => callbacks.headerClick(e, 'payee')}>
              <styles_1.ColumnField>
                {txConfig.fieldData[field].label}
              </styles_1.ColumnField>
              {props.sortBy === 'payee' &&
                            <ArrowUpward_1.default className={classes[sortClass]} viewBox="-1 -1 27 27"/>}
            </styles_1.HdrListItem>);
                    break;
                //--------------------------------------------
                // NOTES FIELD
                //--------------------------------------------
                case 'notes':
                    retRow.push(<styles_1.HdrListItem id="notes-header" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={(0, classnames_1.default)(classes.regItem, 'flex2', 'click')}>
              <styles_1.ColumnField>
                {txConfig.fieldData[field].label}
              </styles_1.ColumnField>
            </styles_1.HdrListItem>);
                    break;
                //--------------------------------------------
                // CATEGORY FIELD
                //--------------------------------------------
                case 'category':
                    retRow.push(<styles_1.HdrListItem id="category-header" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={(0, classnames_1.default)(classes.regItem, 'flex2 click')} onClick={(e) => callbacks.headerClick(e, 'category')}>
              <styles_1.ColumnField>
                {txConfig.fieldData[field].label}
              </styles_1.ColumnField>
              {props.sortBy === 'category' &&
                            <ArrowUpward_1.default className={classes[sortClass]} viewBox="-1 -1 27 27"/>}
            </styles_1.HdrListItem>);
                    break;
                //--------------------------------------------
                // SPLIT FIELD
                //--------------------------------------------
                case 'split':
                    retRow.push(<styles_1.HdrListItem id="split-header" privateKey="regHdr:split" privateClassName={classes.iconColumn}>
              {/*
                        <MUISplitIcon
                          className={classes.regIcon}
                          viewBox="-2 -0 27 27"
                        />
                        */}
            </styles_1.HdrListItem>);
                    break;
                //--------------------------------------------
                // STATE FIELD
                //--------------------------------------------
                case 'state':
                    retRow.push(<styles_1.HdrListItem id="state-header" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={(0, classnames_1.default)(classes.statusColumn, 'click')} onClick={(e) => callbacks.headerClick(e, 'status')}>
              <styles_1.ColumnField>
                {txConfig.fieldData[field].label}
              </styles_1.ColumnField>
              {props.sortBy === 'status' &&
                            <ArrowUpward_1.default className={classes[sortClass]} viewBox="-1 -1 27 27"/>}
            </styles_1.HdrListItem>);
                    break;
                //--------------------------------------------
                // ATTACHMENT FIELD
                //--------------------------------------------
                case 'attachment':
                    if (props.uiState.showAttachmentColumnInHeader) {
                        retRow.push(<styles_1.HdrListItem id="attachment-header" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={classes.iconColumn}>
                {<AttachFile_1.default className={classes.regIcon} viewBox="-2 -4 30 30"/>}
              </styles_1.HdrListItem>);
                    }
                    else {
                        retRow.push(<styles_1.HdrListItem privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={classes.iconButtonColumn}/>);
                    }
                    break;
                //--------------------------------------------
                // EXPENSE FIELD
                //--------------------------------------------
                case 'expense':
                    if (props.doubleAmounts) {
                        retRow.push(<styles_1.HdrListItem id="expense-header" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={(0, classnames_1.default)(classes.regItem, 'amount', 'click', 'protectWidth')} onClick={(e) => callbacks.headerClick(e, 'expense')}>
                <styles_1.ColumnField>
                  {txConfig.fieldData[field].label}
                </styles_1.ColumnField>
                {props.sortBy === 'amount' &&
                                <ArrowUpward_1.default className={classes[sortClass]} viewBox="-1 -1 27 27"/>}
              </styles_1.HdrListItem>);
                    }
                    else {
                        retRow.push(<styles_1.HdrListItem privateClassName={classes.nop} fieldName={`${field}`} privateKey={`regHdr:${field}`}/>);
                    }
                    break;
                //--------------------------------------------
                // INCOME FIELD
                //--------------------------------------------
                case 'income':
                    if (props.doubleAmounts) {
                        retRow.push(<styles_1.HdrListItem id="income-header" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={(0, classnames_1.default)(classes.regItem, 'amount', 'click', 'protectWidth')} onClick={(e) => callbacks.headerClick(e, 'income')}>
                <styles_1.ColumnField>
                  {txConfig.fieldData[field].label}
                </styles_1.ColumnField>
                {props.sortBy === 'amount' &&
                                <ArrowUpward_1.default className={classes[antiSortClass]} viewBox="-1 -1 27 27"/>}
              </styles_1.HdrListItem>);
                    }
                    else {
                        retRow.push(<styles_1.HdrListItem privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={classes.nop}/>);
                    }
                    break;
                //--------------------------------------------
                // AMOUNT FIELD
                //--------------------------------------------
                case 'amount':
                    if (!props.doubleAmounts) {
                        retRow.push(<styles_1.HdrListItem id="amount-header" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={(0, classnames_1.default)(classes.regItem, 'amount', 'click', 'protectWidth')} onClick={(e) => callbacks.headerClick(e, 'amount')}>
                <styles_1.ColumnField>
                  {txConfig.fieldData[field].label}
                </styles_1.ColumnField>
                {props.sortBy === 'amount' &&
                                <ArrowUpward_1.default className={classes[sortClass]} viewBox="-1 -1 27 27"/>}
              </styles_1.HdrListItem>);
                    }
                    else {
                        retRow.push(<styles_1.HdrListItem privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={classes.nop}/>);
                    }
                    break;
                //--------------------------------------------
                // BALANCE
                //--------------------------------------------
                case 'balance':
                    if (showBalance) {
                        retRow.push(<styles_1.HdrListItem id="balance-header" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={(0, classnames_1.default)('amount', classes.regItem, classes.balanceHeader)}>
                <styles_1.ColumnField>
                  {txConfig.fieldData[field].label}
                </styles_1.ColumnField>
              </styles_1.HdrListItem>);
                    }
                    else {
                        retRow.push(<styles_1.HdrListItem privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={classes.nop}/>);
                    }
                    break;
                //--------------------------------------------
                // MENU FIELD
                //--------------------------------------------
                case 'menu': {
                    const customItems = [];
                    if (transactionCalendar) {
                        customItems.push({
                            label: 'Calendar...',
                            value: 'calendar',
                        });
                    }
                    if (props.accountIds.size === 1 && reconcileAccount && hasWriteAccess) {
                        customItems.push({
                            label: 'Reconcile Account...',
                            value: 'reconcile',
                        });
                    }
                    // This actually should be getting the accountNode id for superRegisters, but we don't have access
                    // to that. Since right now only CREDIT registers have their own regFields sort order, and since
                    // the first account in this group will be of type credit, this actually works, but we need to do
                    // a more siginficant refactoring
                    //
                    const firstAccount = (accountsById === null || accountsById === void 0 ? void 0 : accountsById.get((_a = props.accountIds) === null || _a === void 0 ? void 0 : _a.first())) || (accountsById === null || accountsById === void 0 ? void 0 : accountsById.first());
                    const accountType = (firstAccount === null || firstAccount === void 0 ? void 0 : firstAccount.type) || 'bank';
                    retRow.push(<styles_1.HdrListItem privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={classes.iconButtonColumn}>
              <styles_1.ColumnField>
                {(!props.noNew || (isEntityShareEnableUser && !location.pathname.startsWith('/reports'))) &&
                            <TxPrefMenu_1.default colorBlack selected={datasetPreferences.transactionRegister.registerComfort} onChange={(v) => handleSettingsChange(v)} customItems={customItems} accountType={accountType} showIsReviewedColumn={showIsReviewedColumn} isWindowsDataset={isQWinDataset}/>}
              </styles_1.ColumnField>
            </styles_1.HdrListItem>);
                    break;
                }
                //--------------------------------------------
                // SAVE FIELD
                //--------------------------------------------
                case 'save':
                    retRow.push(<styles_1.HdrListItem privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={(0, classnames_1.default)(classes.iconButtonColumn, 'skinny')}/>);
                    break;
                //--------------------------------------------
                // CLOSE FIELD
                //--------------------------------------------
                case 'close':
                    if (txnCancelExtraColumn) {
                        retRow.push(<styles_1.HdrListItem id="regHdrSelectAll" privateKey={`regHdr:${field}`} fieldName={`${field}`} privateClassName={(0, classnames_1.default)(classes.iconButtonColumn, 'skinny')}>
              </styles_1.HdrListItem>);
                    }
                    break;
                default:
                    log.error(`field type ${field} not implemented`);
                    break;
            }
        });
        return retRow;
    };
    const renderTransactionsHeader = () => {
        var _a;
        const { showBalance, sortOrder, accountIds, uiState, callbacks, calendarDate, innerRegRef, showControls, hideSearch, acctTxns, transactionListMetrics, reminderSetting, noNew, dataset, showDebtErrorMessage, hideColumnsHeader, draggableFields } = props;
        const sortClass = sortOrder === 'ascending' ? 'turnUp' : 'turnDown';
        const antiSortClass = sortOrder === 'descending' ? 'turnUp' : 'turnDown';
        // const multiAccount = accountIds.size !== 1;  // TODO what if there is only 1 account?
        const fieldItems = renderFields({ sortClass, antiSortClass, showBalance });
        const txnsAreSelected = ((_a = uiState.selectedTxns) === null || _a === void 0 ? void 0 : _a.size) > 0;
        const doFastCat = transactionsWithCategorySuggestions &&
            transactionsWithCategorySuggestions.size > 0 &&
            suggestCategoryForUncategorized;
        return (<div>
        {showRegPrefs &&
                <RegPrefsModal_1.default onClose={closeRegPrefs}>
          </RegPrefsModal_1.default>}

        {showReconcile &&
                <ReconcilePanel_1.default onClose={() => setShowReconcile(false)} accountId={accountIds.first()}>
          </ReconcilePanel_1.default>}

        {showCalendar &&
                <TransactionCalendar_1.default onClose={() => setShowCalendar(false)} navFn={(txn) => callbacks.scrollToTransaction(txn.id)} inDialog year={calendarDate.get('calendarYear')} month={calendarDate.get('calendarMonth')} setDate={callbacks.setCalendarDate} accountIds={accountIds}>
          </TransactionCalendar_1.default>}

        <styles_1.RegHeader onClick={maybeCancel} ref={(e) => {
                if (innerRegRef) {
                    return innerRegRef(e);
                }
                return null;
            }}>
          {showControls && !txnsAreSelected &&
                <div>
              {!hideSearch &&
                        <RegControlBar_1.default onFastCategorize={doFastCat ? (e) => {
                                e.stopPropagation();
                                callbacks.fastCategorize();
                            } : undefined} 
                        // @ts-expect-error: Property 'onRefresh' does not exist on type
                        onRefresh={callbacks.refreshTxnList} onSearch={callbacks.onSearchFilter} filter={uiState.searchBoxFilter} onApplyFilter={callbacks.onApplyFilter} filterObject={uiState.filterObject} downloadFile={callbacks.downloadFile} acctTxns={acctTxns} transactionListMetrics={transactionListMetrics} scheduledTransactionsInRegister={scheduledTransactionsInRegister} reminderSetting={reminderSetting} onReminderChange={accountIds.size === 1 && callbacks.reminderChange ? callbacks.reminderChange : undefined} showNewTxn={callbacks.showNewTxn} noNew={noNew} isWindowsDataset={Boolean(dataset && datasets_1.datasetsUtils.isWindowsDataset(dataset))} showDebtErrorMessage={showDebtErrorMessage} accountsFilter={accountsFilter} defaultAccountId={accountIds.first()} showAdvancedFilter={showIsReviewedColumn}/>}
            </div>}


          {txnsAreSelected &&
                <RegMEditBar_1.default selectedTxns={uiState.selectedTxns} onEdit={callbacks.editSelectedTxns} onDelete={callbacks.deleteSelectedTxns} onReviewed={() => callbacks.reviewSelectedTxns(true)} onNotReviewed={() => callbacks.reviewSelectedTxns(false)} onMatch={callbacks.matchSelectedTxns} onDownload={callbacks.downloadFile} showReviewOptions={showIsReviewedColumn} isWindowsDataset={isQWinDataset}/>}

          {!hideColumnsHeader &&
                <div className={classes.regColumnsHeader}>
              {fieldItems.map((item) => {
                        const draggableDroppable = draggableFields && (0, helpers_1.fieldIsMoveable)(item.props.fieldName);
                        return (<div onDragStart={draggableDroppable ? (e) => onDragStart(e, item.props.fieldName) : undefined} onDragOver={draggableDroppable ? (e) => onDragOver(e, item.props.fieldName) : undefined} onDrop={draggableDroppable ? onDrop : undefined} onDragEnd={draggableDroppable ? onDragEnd : undefined} key={`hdrColumn-${item.props.privateKey}`} draggable={draggableDroppable} className={(0, classnames_1.default)(item.props.privateClassName, draggingOver === item.props.fieldName ? classes.inserting : '')}>
                      {item}
                    </div>);
                    })}
            </div>}
        </styles_1.RegHeader>
      </div>);
    };
    return renderTransactionsHeader();
};
exports.default = RegisterHeader;
